import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { CardsApi, type LostCardRequest } from '@shared/api';

interface LostCardType {
  loading: boolean;
  error: string | null;
  success: boolean;
  create: (request: LostCardRequest, id: string, signal?: AbortSignal) => Promise<void>;
  resetError: () => void;
  clear: () => void;
}

export const useLostCardStore = create<LostCardType>((set) => ({
  loading: false,
  error: null,
  success: false,

  create: ApiUtils.wrapperApi(async (request, id, signal) => {
    try {
      set({ loading: true, error: null, success: false });
      await CardsApi.lostCard(request, id, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), success: false, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  resetError: () => set({ error: null }),

  clear: () => set({ loading: false, error: null, success: false }),
}));
